
.theme-none {
	.svg-quote {
		fill: $colour-highlight;
	}
}

.theme-drink,
.theme-active,
.theme-weight,
.theme-smoke {
	.cb-hero {
		&:before {
			background-position: -150px -550px;
			background-size: 1700px auto;

			@include min(1400px) {
				background-position: right top -35vw;
				background-size: 100vw auto;
			}
		}
	}
}


.theme-drink {
	.svg-quote {
		fill: $colour-drink;
		opacity: 1;
	}
	.cb-banner,
	.cb-hero,
	.cb-quote {
		&:before {
			background-image: url(/site/images/flower-drink.svg);
		}
	}

	.cb-info {
		.cb-info_block {
			&:nth-child(2n+1) {
				background-color: $colour-drink;

				.link {
					@extend .link__base;
				}
			}
			&:nth-child(2n+2) {
				background-color: #9c9e1b;

				.link {
					@extend .link__white;
				}
			}
		}
	}
}

.theme-active {
	.svg-quote {
		fill: $colour-active;
		opacity: 1;
	}
	.cb-banner,
	.cb-hero,
	.cb-quote {
		&:before {
			background-image: url(/site/images/flower-active.svg);
		}
	}

	.cb-info {
		.cb-info_block {
			&:nth-child(2n+1) {
				background-color: $colour-active;

				.link {
					@extend .link__white;
				}
			}
			&:nth-child(2n+2) {
				background-color: #107985;

				.link {
					@extend .link__white;
				}
			}
		}
	}
}

.theme-weight {
	.svg-quote {
		fill: $colour-weight;
		opacity: 1;
	}
	.cb-banner,
	.cb-hero,
	.cb-quote {
		&:before {
			background-image: url(/site/images/flower-weight.svg);
		}
	}

	.cb-info {
		.cb-info_block {
			&:nth-child(2n+1) {
				background-color: $colour-weight;

				.link {
					@extend .link__white;
				}
			}
			&:nth-child(2n+2) {
				background-color: #420c4b;

				.link {
					@extend .link__white;
				}
			}
		}
	}
}

.theme-smoke {
	.svg-quote {
		fill: $colour-smoking;
		opacity: 1;
	}
	.cb-banner,
	.cb-hero,
	.cb-quote {
		&:before {
			background-image: url(/site/images/flower-smoking.svg);
		}
	}

	.cb-info {
		.cb-info_block {
			&:nth-child(2n+1) {
				background-color: $colour-smoking; // cd2627

				.link {
					@extend .link__white;
				}
			}
			&:nth-child(2n+2) {
				background-color: #9a0e0f;

				.link {
					@extend .link__white;
				}
			}
		}
	}
}